import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.sub.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.error.cause.js";
import { DateTime } from 'luxon';
import { getBetaFilesApi, getBetaDownloadUrlApi, uploadBetaFileApi } from '@/api/betaFolder';
var FOLDERS = [{
  key: '結案回饋',
  icon: 'fas fa-clipboard-check',
  upload: true,
  hint: '有新推播的那天會產一份。下載 → 用 Excel 填黃色欄位 → 存檔 → 上傳。上傳會另存新檔（加上帳號與時間），不會蓋掉別人的；系統依案件編號合併，空白欄不會洗掉已填的值。'
}, {
  key: '監控告警',
  icon: 'fas fa-bell',
  upload: true,
  hint: '每週五早上自動匯出上週五～週四的監控告警（格式同即時頁的告警下載），算召回率用。要補手動匯出的檔也可以上傳。'
}, {
  key: '週包',
  icon: 'fas fa-file-archive',
  hint: '週五～週四 7 天的每日結果＋全部結案 Excel＋當週監控告警，每週五上傳去算精確率、召回率與 F1。'
}, {
  key: '每日結果',
  icon: 'fas fa-calendar-day',
  hint: '每天的 cases、alarms、dq_log、run_log（只留當天）。'
}, {
  key: '摘要',
  icon: 'fas fa-envelope',
  hint: '每天寄出的摘要信備份。'
}];
var fmtSize = function fmtSize(n) {
  return n >= 1048576 ? "".concat((n / 1048576).toFixed(1), " MB") : "".concat(Math.max(1, Math.round(n / 1024)), " KB");
};
export default {
  name: 'BetaFolder',
  data: function data() {
    return {
      FOLDERS: FOLDERS,
      files: [],
      root: '',
      tabIndex: 0,
      loading: false,
      uploading: false,
      error: '',
      notice: '',
      fields: [{
        key: 'base',
        label: '檔名'
      }, {
        key: 'time',
        label: '更新時間',
        thClass: 'bf_nowrap',
        tdClass: 'bf_nowrap'
      }, {
        key: 'sizeText',
        label: '大小',
        thClass: 'bf_nowrap',
        tdClass: 'bf_nowrap'
      }, {
        key: 'uploadedBy',
        label: '上傳者'
      }],
      dailyFields: [{
        key: 'date',
        label: '資料日期',
        thClass: 'bf_nowrap',
        tdClass: 'bf_nowrap'
      }, {
        key: 'files',
        label: '檔案'
      }, {
        key: 'time',
        label: '更新時間',
        thClass: 'bf_nowrap',
        tdClass: 'bf_nowrap'
      }]
    };
  },
  computed: {
    // 第一層是案場代號；測試用的前綴（例如「彩排」）底下多一層案場
    roots: function roots() {
      var set = new Set();
      var _iterator = _createForOfIteratorHelper(this.files),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var f = _step.value;
          var parts = f.name.split('/');
          var i = parts.findIndex(function (p) {
            return FOLDERS.some(function (x) {
              return x.key === p;
            });
          });
          if (i > 0) set.add(parts.slice(0, i).join('/'));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return _toConsumableArray(set).sort(function (a, b) {
        return a.length - b.length || a.localeCompare(b);
      });
    },
    rows: function rows() {
      var _this = this;
      return this.files.filter(function (f) {
        return f.name.startsWith(_this.root + '/');
      }).map(function (f) {
        var rest = f.name.slice(_this.root.length + 1).split('/');
        return _objectSpread(_objectSpread({}, f), {}, {
          folder: rest[0],
          sub: rest.length > 2 ? rest[1] : '',
          base: rest[rest.length - 1],
          time: DateTime.fromISO(f.mtime).setZone('Asia/Taipei').toFormat('yyyy-MM-dd HH:mm'),
          sizeText: fmtSize(f.size)
        });
      }).sort(function (a, b) {
        return b.mtime.localeCompare(a.mtime) || b.base.localeCompare(a.base);
      });
    },
    dailyRows: function dailyRows() {
      var map = new Map();
      var _iterator2 = _createForOfIteratorHelper(this.rowsOf('每日結果')),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var r = _step2.value;
          if (!map.has(r.sub)) map.set(r.sub, {
            date: r.sub,
            files: [],
            time: r.time
          });
          map.get(r.sub).files.push(r);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return _toConsumableArray(map.values()).map(function (d) {
        return _objectSpread(_objectSpread({}, d), {}, {
          files: d.files.sort(function (a, b) {
            return a.base.localeCompare(b.base);
          })
        });
      }).sort(function (a, b) {
        return b.date.localeCompare(a.date);
      });
    }
  },
  watch: {
    roots: function roots(list) {
      if (!list.includes(this.root)) this.root = list[0] || '';
    }
  },
  created: function created() {
    this.load();
  },
  methods: {
    rowsOf: function rowsOf(folder) {
      return this.rows.filter(function (r) {
        return r.folder === folder;
      });
    },
    load: function load() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                _this2.error = '';
                _context.prev = 2;
                _context.next = 5;
                return getBetaFilesApi();
              case 5:
                _context.t0 = _context.sent.data;
                if (_context.t0) {
                  _context.next = 8;
                  break;
                }
                _context.t0 = [];
              case 8:
                _this2.files = _context.t0;
                _context.next = 14;
                break;
              case 11:
                _context.prev = 11;
                _context.t1 = _context["catch"](2);
                _this2.error = (_context.t1 === null || _context.t1 === void 0 ? void 0 : _context.t1.msg) || (_context.t1 === null || _context.t1 === void 0 ? void 0 : _context.t1.message) || '讀不到資料夾';
              case 14:
                _context.prev = 14;
                _this2.loading = false;
                return _context.finish(14);
              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 11, 14, 17]]);
      }))();
    },
    download: function download(name) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var link;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                link = document.createElement('a');
                _context2.next = 4;
                return getBetaDownloadUrlApi(name);
              case 4:
                link.href = _context2.sent;
                link.target = '_blank';
                link.rel = 'noopener';
                link.click();
                _context2.next = 13;
                break;
              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                _this3.error = (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.msg) || (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || '下載失敗';
              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 10]]);
      }))();
    },
    upload: function upload(folder, ev) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var file, dataBase64, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                file = ev.target.files[0];
                ev.target.value = '';
                if (file) {
                  _context3.next = 4;
                  break;
                }
                return _context3.abrupt("return");
              case 4:
                _this4.uploading = true;
                _this4.error = '';
                _context3.prev = 6;
                _context3.next = 9;
                return new Promise(function (resolve, reject) {
                  var r = new FileReader();
                  r.onload = function () {
                    return resolve(String(r.result).split(',')[1]);
                  };
                  r.onerror = function () {
                    return reject(new Error('讀不到檔案'));
                  };
                  r.readAsDataURL(file);
                });
              case 9:
                dataBase64 = _context3.sent;
                _context3.next = 12;
                return uploadBetaFileApi(_this4.root, folder, file.name, dataBase64);
              case 12:
                res = _context3.sent;
                _this4.notice = "\u5DF2\u4E0A\u50B3\uFF1A".concat(res.data.name.split('/').pop());
                _context3.next = 16;
                return _this4.load();
              case 16:
                _context3.next = 21;
                break;
              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](6);
                _this4.error = (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.msg) || (_context3.t0 === null || _context3.t0 === void 0 ? void 0 : _context3.t0.message) || '上傳失敗';
              case 21:
                _context3.prev = 21;
                _this4.uploading = false;
                return _context3.finish(21);
              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[6, 18, 21, 24]]);
      }))();
    }
  }
};